(function () {
  if (window.AxiomMobileImagePriorityLoaded) return;
  window.AxiomMobileImagePriorityLoaded = true;

  var MOBILE_MEDIA_QUERY = '(max-width: 767px)';
  var LAZY_IMAGE_SELECTOR = 'img[loading="lazy"]';
  var mobileMediaQuery = window.matchMedia ? window.matchMedia(MOBILE_MEDIA_QUERY) : null;
  var observer = null;

  function isMobileViewport() {
    return Boolean(mobileMediaQuery && mobileMediaQuery.matches);
  }

  function isEligible(image) {
    return image
      && image.matches(LAZY_IMAGE_SELECTOR)
      && image.dataset.mobileImagePriority !== 'true'
      && !image.complete
      && !image.closest('[hidden], [aria-hidden="true"], template');
  }

  function promote(image) {
    if (!isEligible(image)) return;

    image.dataset.mobileImagePriority = 'true';
    // Safari's native lazy-load threshold is browser controlled. Promote media
    // before it reaches the viewport so decoding does not compete with scrolling.
    image.loading = 'eager';
    image.setAttribute('loading', 'eager');
    if (observer) observer.unobserve(image);
  }

  function ensureObserver() {
    if (observer || !('IntersectionObserver' in window)) return observer;

    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) promote(entry.target);
      });
    }, {
      rootMargin: '0px 0px 125% 0px'
    });

    return observer;
  }

  // Horizontal rails and sliders clip their cards, so a card just off the rail's
  // edge never intersects the page observer and only starts loading once it is
  // swiped in (a blank card for a moment). When a rail comes near the screen,
  // a second observer rooted on the rail promotes the cards within one and a
  // half rail widths of what is showing.
  var railImages = new Map();
  var railWatchers = new Map();
  var railObserver = null;

  function findRail(image) {
    var el = image.parentElement;
    for (var depth = 0; el && el !== document.body && depth < 12; depth += 1) {
      var overflowX = window.getComputedStyle(el).overflowX;
      if (overflowX !== 'visible' && el.scrollWidth > el.clientWidth + 1) return el;
      el = el.parentElement;
    }
    return null;
  }

  function watchRail(rail) {
    var inner = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          promote(entry.target);
          inner.unobserve(entry.target);
        }
      });
    }, { root: rail, rootMargin: '0px 150% 0px 150%' });
    railWatchers.set(rail, inner);
    railImages.get(rail).forEach(function (image) {
      if (isEligible(image)) inner.observe(image);
    });
  }

  function ensureRailObserver() {
    if (railObserver || !('IntersectionObserver' in window)) return railObserver;

    railObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        railObserver.unobserve(entry.target);
        watchRail(entry.target);
      });
    }, {
      rootMargin: '0px 0px 125% 0px'
    });

    return railObserver;
  }

  // The observer sees what a box test cannot: images that are not rendered
  // (display: none) never intersect, so only media the shopper can reach by
  // scrolling down (or by swiping a rail that is on screen) load early.
  function observeImage(image) {
    if (!isEligible(image)) return;

    var imageObserver = ensureObserver();
    if (imageObserver) imageObserver.observe(image);

    var rail = findRail(image);
    if (!rail || !ensureRailObserver()) return;
    if (railWatchers.has(rail)) {
      railWatchers.get(rail).observe(image);
      return;
    }
    if (!railImages.has(rail)) {
      railImages.set(rail, []);
      railObserver.observe(rail);
    }
    railImages.get(rail).push(image);
  }

  function initialize(scope) {
    if (!isMobileViewport()) return;

    var root = scope instanceof Element ? scope : document;
    if (root.matches && root.matches(LAZY_IMAGE_SELECTOR)) observeImage(root);
    root.querySelectorAll(LAZY_IMAGE_SELECTOR).forEach(observeImage);
  }

  function handleViewportChange(event) {
    if (event.matches) {
      initialize(document);
      return;
    }

    if (observer) {
      observer.disconnect();
      observer = null;
    }
    if (railObserver) {
      railObserver.disconnect();
      railObserver = null;
    }
    railWatchers.forEach(function (inner) { inner.disconnect(); });
    railWatchers.clear();
    railImages.clear();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  document.addEventListener('axiom:recommendations:loaded', function (event) { initialize(event.target); });

  if (mobileMediaQuery) {
    if (typeof mobileMediaQuery.addEventListener === 'function') {
      mobileMediaQuery.addEventListener('change', handleViewportChange);
    } else if (typeof mobileMediaQuery.addListener === 'function') {
      mobileMediaQuery.addListener(handleViewportChange);
    }
  }
})();
